module.exports = __webpack_public_path__ + "static/media/disasterSingle.18262f73.JPG";